import { useMutation } from '@tanstack/react-query'

import type {
  CreateReservationRequest,
  CreateReservationResponse,
} from '../../types/reservation.js'

import { apiClient } from '../../lib/client.js'
import { writeReservationToken } from '../public-reservation/reservation-token.js'
import { quoteAuthHeaders } from './quote-token.js'

export const useCreatePublicQuoteReservationMutation = () =>
  useMutation({
    mutationFn: async ({
      responseId,
      ...request
    }: CreateReservationRequest & { responseId: string }) => {
      const response = await apiClient.client.post<CreateReservationResponse>(
        `/public/estimate-responses/${responseId}/reservation`,
        request,
        { headers: quoteAuthHeaders(responseId) }
      )

      // Le serveur rend un jeton de portée `reservation` : sans lui, la page de
      // confirmation redemanderait son nom au client une seconde après l'envoi.
      writeReservationToken(response.data.id, response.data.accessToken)

      return response.data
    },
  })
